var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMkdFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_62581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H60V45H0V0Z",
    fill: "#D20000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H9L30 21.6937L51 0H60L0 45H9L30 23.3063L51 45H60L0 0ZM60 18V27L0 18V27L60 18ZM26.25 0L30 19.2844L33.75 0H26.25ZM26.25 45L30 25.7156L33.75 45H26.25Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0001 29.7282C33.9921 29.7282 37.2282 26.4921 37.2282 22.5001C37.2282 18.5081 33.9921 15.272 30.0001 15.272C26.0081 15.272 22.772 18.5081 22.772 22.5001C22.772 26.4921 26.0081 29.7282 30.0001 29.7282Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9999 16.0733C26.4506 16.0733 23.5733 18.9506 23.5733 22.4999C23.5733 26.0492 26.4506 28.9265 29.9999 28.9265C33.5492 28.9265 36.4265 26.0492 36.4265 22.4999C36.4265 18.9506 33.5492 16.0733 29.9999 16.0733ZM21.9702 22.4999C21.9702 18.0652 25.5652 14.4702 29.9999 14.4702C34.4346 14.4702 38.0296 18.0652 38.0296 22.4999C38.0296 26.9346 34.4346 30.5296 29.9999 30.5296C25.5652 30.5296 21.9702 26.9346 21.9702 22.4999Z",
    fill: "#D20000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_62581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMkdFlag);
export default __webpack_public_path__ + "static/media/mkd-flag.a2c22f6e511a3a41ecacfcde7d264225.svg";
export { ForwardRef as ReactComponent };